module.exports = __webpack_public_path__ + "media/images/icon__backArrow--lightGray-cbd5b170a4c80fa9e974b485ae178404.svg";